import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../services/authAPI";
import moment from "moment";
import "moment/locale/fr";
import Field from "../components/Field";
import { STATUS_OPTIONS, STATUS_CLASSES } from "../constants/tickets";

export default function TicketsPage() {
    const navigate = useNavigate();
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tickets, setTickets] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    async function fetchTickets() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/tickets`);
            if (!response.ok) {
                setError("Une erreur est survenue");
                return;
            }
            const data = await response.json();
            setTickets(data);
        } catch (err) {
            setError("Erreur lors du chargement des tickets.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        async function fetchBrands() {
            try {
                const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicle_brands`);
                const data = await response.json();
                setBrands(data);
            } catch {
                // silently handled
            }
        }

        fetchTickets();
        fetchBrands();
    }, []);

    if (loading) {
        return (
            <section>
                <div className="card mb-4">
                    <div className="card-body py-5 px-5 text-center">
                        <p className="text-muted">Chargement...</p>
                    </div>
                </div>
            </section>
        );
    }

    const filteredTickets = tickets.filter((ticket) => {
        const s = search.toLowerCase();
        return (
            ticket.ticketNumber?.toLowerCase().includes(s) ||
            ticket.description?.toLowerCase().includes(s)
        );
    });

    if (error || !tickets) {
        return (
            <section>
                <div className="card mb-4">
                    <div className="card-body py-5 px-5 text-center">
                        <p className="text-danger">{error ?? "Ticket introuvable."}</p>
                        <button className="btn btn-link" onClick={() => navigate("/tickets")}>
                            Retour aux tickets
                        </button>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
        <section>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                            <Field
                                name="search"
                                label="Rechercher un ticket..."
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                }}
                                type="text"
                                margin={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {filteredTickets.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {filteredTickets.map((ticket) => (
                        <div className="card" key={ticket.id} style={{ cursor: "pointer" }} onClick={() => navigate(`/tickets/${ticket.id}`)}>
                            <div className="card-header">
                                <h5 className="card-title">
                                    {ticket.ticketNumber}
                                    <span className={"ms-2 badge bg-" + (STATUS_CLASSES[ticket.status] ?? "secondary")}>
                                        {STATUS_OPTIONS[ticket.status] ?? ticket.status}
                                    </span>
                                </h5>
                                <small className="text-muted mb-1" style={{ fontSize: "0.85rem" }}>
                                    Crée le {moment(ticket.createdAt).locale("fr").format("Do MMMM YYYY [à] HH:mm")}
                                </small>
                            </div>
                            <div className="card-body">
                                {ticket.mileage && (
                                    <small className="text-muted">{ticket.mileage.toLocaleString("fr-FR")} km</small>
                                )}
                                <p className="card-text">{ticket.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-muted text-center">Aucun ticket associé à ce véhicule.</p>
            )}
        </section>
    </>
    );
}
